import React, {
  ReactElement,
  LazyExoticComponent,
  Suspense,
} from 'react';
import { APP, PAGE_NAMES } from 'appenv';
import Routes from 'Routes';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { Booth } from 'models/exhibitors';
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import Typography from '@material-ui/core/Typography';
import Footer from 'components/Footer';
import BoothPreview from './BoothPreview';
import BreadcrumbsNoFilterContainer from './BreadcrumbsNoFilterContainer';

const IEBreadcrumbsNoFilterContainer = styled(BreadcrumbsNoFilterContainer)`
  flex-basis: 100%;
`;

const IEBoothListContainer = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
`;

const StyledLink = styled(Link)`
  text-decoration: none;
`;

const FooterWrapper = styled.div`
  flex-basis: 100%;
`;

let HallPageHeader: LazyExoticComponent<() => ReactElement> | (() => ReactElement) = () => <div />;
if (APP === 'polyu618') {
  HallPageHeader = React.lazy(() => import('./PolyU618Header'));
}

const IEBoothList = ({
  exhibitors = [],
  isDesktop,
  hasFilter,
}: {
  isDesktop: boolean;
  exhibitors: Booth[];
  hasFilter: boolean;
}) => (
  <IEBoothListContainer>
    {!(hasFilter && isDesktop) && (
      <IEBreadcrumbsNoFilterContainer>
        <Breadcrumbs aria-label="breadcrumb" separator=">">
          <StyledLink to={Routes.lobby}>
            {PAGE_NAMES.lobby}
          </StyledLink>
          <Typography color="textPrimary">
            {PAGE_NAMES.hall}
          </Typography>
        </Breadcrumbs>
      </IEBreadcrumbsNoFilterContainer>
    )}
    <Suspense fallback={null}>
      <HallPageHeader />
    </Suspense>
    {exhibitors.map((booth, index) => (
      <BoothPreview
        booth={booth}
        index={index}
      />
    ))}
    <FooterWrapper>
      <Footer hashState="/hall" />
    </FooterWrapper>
  </IEBoothListContainer>
);

export default IEBoothList;
